export default __webpack_public_path__ + "static/decoration4-809947e735c2961c9b356ea6095a4dfe.png";